import { combineReducers } from 'redux'

import AuthConstants from "./auth/AuthConstants";

import * as AuthReducer from './auth/AuthReducer';
import * as StoryReducers from './stories/StoryReducers';
import * as AccountReducers from './accounts/AccountReducers';
import * as SlideReducers from './slides/SlideReducers';
import * as ElementReducers from './elements/ElementReducers';
import * as MediaReducers from './media/MediaReducers';
import * as IntegrationsReducers from './integrations/IntegrationsReducer';
import * as PostReducers from './posts/PostReducers';
import * as ProjectReducers from './projects/ProjectReducers';
import * as NotificationReducers from './notifications/NotificationReducers';
import * as UserReducers from './users/UserReducers';

const appReducer = combineReducers({
    ...AuthReducer,
    ...StoryReducers,
    ...AccountReducers,
    ...SlideReducers,
    ...ElementReducers,
    ...MediaReducers,
    ...IntegrationsReducers,
    ...PostReducers,
    ...ProjectReducers,
    ...NotificationReducers,
    ...UserReducers
});

export default (state, action) => {

    if (action.type === AuthConstants.AUTH_LOGGED_OUT) {
        return appReducer(undefined, action);
    }

    return appReducer(state, action);
}
